import React, {useEffect} from "react";
import {useParams, useNavigate} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import useCoupon from "./useCoupon";

export default function () {
  const {reset, handleSubmit, setErrors, couponFields, setData} = useCoupon();
  const {id} = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`coupons/${id}/edit`).then(res => {
      setData({...res.data.data, isEditMode: true});
      reset(res.data.coupon);
    });
  }, []);

  const editCoupon = data => {
    axios.put(`coupons/${id}`, data).then(function (res) {
      navigate('/coupons');
    }).catch(function (error) {
      if (error.response) {
        setErrors(error.response.data.errors || {});
      }
    });
  }

  return (
    <Card title="Edit slider">
      <form className="form w-100 row" onSubmit={handleSubmit(editCoupon)}>
        {couponFields}
        <div className="col-12">
          <SubmitButton title="Update" classes="d-inline-block w-auto"/>
        </div>
      </form>
    </Card>
  );
}